import { useState, useEffect } from 'react';
import { Button, IconButton, Typography } from "@mui/material";
import { Navigate } from "react-router-dom";
import { Logout, Help } from "@mui/icons-material";
import logoutBackend from '../../shared/api/logoutBackend';
import { SystemErrorMsg, SystemErrorTitle } from '../../constants';

type SignOut = {
    signOut: any;
}

export const HeaderToLogout = ({signOut} : SignOut) => {
    const [logoutError, setLogoutError] = useState<boolean>(false);

    //画面遷移後、フラグをすぐ戻す
    useEffect(() => {
        if (!logoutError) return;
        setLogoutError(false);
    }, [logoutError]);

    // // サインアウト処理
    const handleSignOut = async (signOut: any) => {
        // ログアウト(サーバーサイド)
        const logoutResponse = await logoutBackend();

        if (!logoutResponse) {
            setLogoutError(true);
            return;
        }

        // サインアウト(Authenticator)
        signOut();
        // セッションストレージのクリア
        sessionStorage.clear();
        window.history.replaceState("", "", "/");
    }

    return (
        <>
            <IconButton sx={{ color: "#01CFBE" }} aria-label="menu" onClick={() => window.open("https://www.tsr-net.co.jp/static/tsr-eyes/help/")}><Help /></IconButton>
            {logoutError && <Navigate to="/Error" replace state={{ title: SystemErrorTitle, message: SystemErrorMsg }} />}
            <IconButton sx={{ color: "#01CFBE" }} aria-label="menu" onClick={() => handleSignOut(signOut)}><Logout /></IconButton>
        </>
    );
}